import * as React from 'react';
export type NLSSelectListPropsType = {
  defaultValue: string | boolean;
  name: string;
  label: string;
  register: any;
  options: any;
};
export const NLSSelectList = ({
  defaultValue,
  name,
  label,
  register,
  options,
}: NLSSelectListPropsType) => {
  return (
    <div className="mb-4">
      <label
        className="block text-gray-700 text-sm font-bold mb-2"
        htmlFor={name}
      >
        {label}
      </label>
      <select defaultValue={defaultValue} {...register(name)}>
        {options
          .sort((a: any, b: any) => (a.option >= b.option ? 1 : -1))
          .map((option: any) => (
            <option value={option.index} key={option.index}>
              {option.option}
            </option>
          ))}
      </select>
    </div>
  );
};
